// extracted by mini-css-extract-plugin
export default {"wrapper":"Error_wrapper__v1x4I","icon":"Error_icon__gC9g7"};